import { useState, useEffect } from 'react'
import getUserMaterialItems from 'src/services/get/getUserMaterialItems'

export const useFetchDataHouse = (userId) => {
  const [items, setItems] = useState([])
  const [rawMaterialItems, setRawMaterialItems] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null)
  const [refresh, setRefresh] = useState(false)

  useEffect(() => {
    const loadItems = async () => {
      if (!userId) {
        return
      }

      setIsLoading(true)
      setError(null)

      try {
        const response = await getUserMaterialItems()

        if (response?.success && response?.items) {
          setRawMaterialItems(response.items)

          const transformedItems = response.items.map((item) => ({
            id: item.id,
            name: item.avatar_name || '',
            category: item.category || 'background',
            icon_url: item.icon_url || '',
            pinned: item.pinned || false,
            width: item.x_space || 1,
            height: item.y_space || 1,
            rightWidth: item.right_x_space || item.x_space || 1,
            rightHeight: item.right_y_space || item.y_space || 1,
            amount: item.amount || 0,
            attached_amount: item.attached_amount || 0,
            individual_space: item.individual_space || 'floor',
            rarity: item.rarity || '',
            left_material_image_url: item.left_material_image_url || '',
            right_material_image_url: item.right_material_image_url || '',
            background_image_url: item.background_image_url || null,
            left_wall_image_url: item.left_wall_image_url || null,
            right_wall_image_url: item.right_wall_image_url || null,
            floor_wall_image_url: item.floor_wall_image_url || null,
            has_attached_icon: item.has_attached_icon || false
          }))
          setItems(transformedItems)
        } else {
          setRawMaterialItems([])
          setItems([])
        }
      } catch (err) {
        console.error('Error loading material items:', err)
        setError(err)
        setRawMaterialItems([])
        setItems([])
      } finally {
        setIsLoading(false)
      }
    }

    loadItems()
  }, [userId, refresh])

  return {
    items,
    rawMaterialItems,
    isLoading,
    error,
    refetch: () => setRefresh((prev) => !prev)
  }
}
